import React from "react";

/**
 * BrainBadge — small pill showing which brain powers something.
 * Consistent across My Workforce, Worker Workspace, Activity, Analytics.
 */
export default function BrainBadge({ brain, size = "md", showFamily = false }) {
  if (!brain) return null;
  const pad = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border-2 font-heading font-bold ${pad}`}
      style={{ backgroundColor: brain.color + "1F", borderColor: brain.color, color: brain.color }}
      title={`${brain.family} · ${brain.name}`}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: brain.color }} />
      {showFamily ? `${brain.family} · ${brain.name}` : brain.name}
    </span>
  );
}
